import generateVersionHash from '@utils/generateVersionHash';
import { postApi } from '@/lib/fetcher';
import { date } from '@/lib/helpers';

const URL_API =
  '/index.php?r=api/v1/closed_merchant_category/ref-closed-merchant-category/index';

const closedMerchantCategorySharedStore = {
  namespaced: true,
  state: {
    loading: false,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async getClosedMerchantCategory(ctx, payload = {}) {
      const { page = 1, limit = 100 } = payload;

      const pageStr = String(page);
      const limitStr = String(limit);

      const data = JSON.stringify({
        page: pageStr,
        limit: limitStr,
        search: {
          code: null,
          category: null,
          description: null,
          status: 1,
        },
        version: generateVersionHash(pageStr + limitStr, date),
      });

      try {
        ctx.commit('setLoading', true);

        const responseData = await postApi(ctx, URL_API, data);

        if (responseData?.code === 200) {
          const list = responseData?.data?.list || [];
          return { success: true, data: list, response: responseData };
        }

        return {
          success: false,
          message: responseData?.message_id || 'Failed to get closed merchant category',
          data: [],
        };
      } catch (error) {
        return { success: false, message: error.message, data: [] };
      } finally {
        ctx.commit('setLoading', false);
      }
    },
  },
};

export default closedMerchantCategorySharedStore;
